import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  variants: {
    size: {
      md: {
        fontSize: 'xl',
      },
      lg: {
        fontSize: '3xl',
      },
      xl: {
        fontSize: '4xl',
      },
      '2xl': {
        fontSize: '5xl',
      },
      '3xl': {
        fontSize: '6xl',
      },
      '4xl': {
        fontSize: '7xl',
      },
    },
  },
});
